import React from "react";
import { LocalKeys, useTranslation } from "utilities/i18n";
import { PolyIcon } from "../PolyIcon";

type VoidFunc = () => void;
type DoFunc = () => {};
type AnyFunc = VoidFunc | DoFunc;

/**
 * Provide a general-purpose Submit button.
 *
 * This was created to aggregate variants, reduce errors and verbosity with submit button
 * implementations.
 */
export const SubmitButton: React.FC<{
  isSubmitting: boolean;
  disabled?: boolean;
  labelKey?: LocalKeys;
  labelKeyData?: Record<string, string | number>;
  submittingLabelKey?: LocalKeys;
  name?: string;
  testId?: string;
  onClick?: AnyFunc;
  className?: string;
}> = ({
  isSubmitting,
  disabled = false,
  name = "submit",
  testId = "submit-button",
  labelKey = "APPLY",
  labelKeyData = {},
  submittingLabelKey = "APPLYING",
  className = "btn btn-primary",
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <button
      type="submit"
      className={className}
      name={name}
      disabled={isSubmitting || disabled}
      data-testid={testId}
      {...rest}
    >
      {isSubmitting ? (
        <span>
          <PolyIcon icon="refresh" className="refresh spin mr-5" />
          {t(submittingLabelKey)}
        </span>
      ) : (
        t(labelKey, labelKeyData)
      )}
    </button>
  );
};
